
export enum LicenseStatusCode {
    NoLicense = "NoLicense",
    LicenseExpired = "Expired",
    LicenseInvalid = "Invalid",
    ValidLicense = "Valid",
    TrialLicense = "Trial",
    TrialExpired = "TrialExpired"
}

/**
* ValueConverter for displaying licensestatus as icon or label.
*/
export class LicenseStatusValueConverter {
    toView(value: LicenseStatusCode, format) {

        if (format === "label") {
            return this.toLabel(value);
        }

        return this.toIcon(value);
    }


    private toIcon(value: LicenseStatusCode): string {
        switch (value) {
            case LicenseStatusCode.NoLicense:
            case LicenseStatusCode.LicenseInvalid:
                return "alert";
            case LicenseStatusCode.LicenseExpired:
                return "remove-sign";
            case LicenseStatusCode.ValidLicense:
            case LicenseStatusCode.TrialLicense:
                return "ok";
            case undefined:
            case null:
                return "hourglass";
        }

        // Something wrong
        return "remove-sign";
    }

    private toLabel(value: LicenseStatusCode): string {
        switch (value) {
            case LicenseStatusCode.NoLicense:
                return "No License";
            case LicenseStatusCode.LicenseExpired:
                return "License Expired";
            case LicenseStatusCode.LicenseInvalid:
                return "License Invalid";
            case LicenseStatusCode.ValidLicense:
                return "Valid License";
            case LicenseStatusCode.TrialLicense:
                return "Trial License";
            case LicenseStatusCode.TrialExpired:
                return "Trial Expired";
            case undefined:
            case null:
                return "Pending...";
        }
        return value;
        // Valid license
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/components/license-status.ts